import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const dealsService = {
  getAllDeals,
  addDeals,
  getDeal,
  getAllDealLocations,
  deleteDeal
};

function getAllDeals(params) {
  return apiCall("GET", apiUrls.deals.base, null, params);
}

function getAllDealLocations(dealId, params) {
  return apiCall(
    "GET",
    `${apiUrls.deals.base}/${dealId}/locations`,
    null,
    params
  );
}

function addDeals(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.deals.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getDeal(id) {
  return apiCall("GET", `${apiUrls.deals.base}/${id}`);
}

function deleteDeal(id) {
  return apiCall("DELETE", `${apiUrls.deals.base}/${id}`);
}
